import React, { useState } from "react";
import { toast } from "react-toastify";
import { phone } from "phone";
import { config } from "../../config";
import { usePaystackPayment } from "react-paystack";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import Notify from "simple-notify";

const bannertitle = "Meet Tegal, Where Love Begins";
const bannerdesc = <p>Request for a partner</p>;

function BannerSection() {
  const [fromAge, setFromAge] = useState("");
  const [toAge, setToAge] = useState("");

  const [input, setInput] = useState({
    gender: "",
    targetGender: "",
    targetAge: "18-18+",
    name: "",
    phoneNumber: "",
    emailAddress: "",
    address: "",
    paidAmount: config.partnerRequestFee,
    paymentRef: "",
    paymentDate: "",
  });

  const [paystackConfig] = useState({
    reference: "",
    email: "",
    amount: config.partnerRequestFee,
    publicKey: config.paystackKey,
  });
  const initializePayment = usePaystackPayment(paystackConfig);

  const continueToPayment = async () => {
    const paymentDate = new Date();
    const paymentRef = paymentDate.getTime().toString();
    const amount = config.partnerRequestFee;

    input.paidAmount = amount / 100;
    input.paymentRef = paymentRef;
    input.paymentDate = paymentDate;

    paystackConfig.reference = paymentRef;
    paystackConfig.email = input.emailAddress;
    initializePayment(
      (reference) => {
        console.log(reference);
        toast.success("Payment successful");
        axios
          .post(config.baseURL + "/api/v1/partner-request/public", input)
          .then(function (response) {
            if (response.data.success) {
              new Notify({
                title: "Request Successul",
                text: "Your request has been submited and we will get back to you in 48 hrs",
                status: "success",
                showCloseButton: true,
                autoclose: false,
              });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            } else {
              toast.warn(response.data.message);
            }
          })
          .catch(function (error) {
            toast.error("Unable to send request");
          });
      },
      () => {
        toast.warn("Payment canceled");
      }
    );
  };
  const submit = () => {
    if (
      input.gender !== "" &&
      input.targetGender !== "" &&
      input.name !== "" &&
      input.phoneNumber !== ""
    ) {
      setInput({ ...input, targetAge: fromAge + "-" + toAge });
      if (phone(input.phoneNumber, { country: "NG" }).isValid) {
        confirmAlert({
          message: `By clicking continue, you agree to pay for non-refundable partner request fee of NGN${(
            config.partnerRequestFee / 100
          ).toLocaleString()}. We will engage you to learn more about the type of ${
            input.gender === "Male" ? "lady" : "man"
          } you are searching for and we will connect both of you.`,
          buttons: [
            {
              color: "#9a2839",
              label: "Cancel",
              onClick: () => {},
            },
            {
              color: "green",
              label: "Continue to Payment",
              onClick: () => continueToPayment(),
            },
          ],
        });
      } else {
        toast.error("Invalid phone number");
      }
    } else {
      toast.warning("All fields required");
    }
  };

  return (
    <section className="banner-section">
      <div className="container">
        <div className="section-wrapper">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <div className="banner-content">
                <div className="intro-form">
                  <div className="intro-form-inner">
                    <h5>{bannertitle}</h5>
                    {bannerdesc}
                    <form action="/" className="banner-form">
                      <div className="gender">
                        <label className="left">
                          I am a <span style={{ color: "#9a2839" }}>*</span>{" "}
                        </label>
                        <div className="custom-select right">
                          <select
                            name="gender"
                            id="gender"
                            onChange={(e) =>
                              setInput({
                                ...input,
                                gender: e.target.value,
                                targetGender:
                                  e.target.value === "Male" ? "Female" : "Male",
                              })
                            }
                          >
                            <option value="">Select Gender</option>
                            <option>Male</option>
                            <option>Female</option>
                          </select>
                        </div>
                      </div>
                      <div className="person">
                        <label className="left">
                          Looking for{" "}
                          <span style={{ color: "#9a2839" }}>*</span>
                        </label>
                        <div className="custom-select right">
                          <select
                            disabled
                            readonly
                            name="gender"
                            id="gender-two"
                            onChange={(e) =>
                              setInput({
                                ...input,
                                targetGender: e.target.value,
                              })
                            }
                          >
                            {input.gender === "Male" ? (
                              <option selected>Female</option>
                            ) : input.gender === "Female" ? (
                              <option selected>Male</option>
                            ) : (
                              <option value="">Select Gender</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="age">
                        <label className="left">
                          Age <span style={{ color: "#9a2839" }}>*</span>
                        </label>
                        <div className="right d-flex justify-content-between">
                          <div className="custom-select">
                            <select
                              name="age-start"
                              id="age"
                              onChange={(e) => setFromAge(e.target.value)}
                            >
                              <option>18</option>
                              <option>19</option>
                              <option>20</option>
                              <option>21</option>
                              <option>22</option>
                              <option>23</option>
                              <option>24</option>
                              <option>25</option>
                              <option>26</option>
                              <option>27</option>
                              <option>28</option>
                              <option>29</option>
                              <option>30</option>
                            </select>
                          </div>
                          <div className="custom-select">
                            <select
                              name="age-end"
                              id="age-two"
                              onChange={(e) => setToAge(e.target.value)}
                            >
                              <option>18+</option>
                              <option>19</option>
                              <option>20</option>
                              <option>21</option>
                              <option>22</option>
                              <option>23</option>
                              <option>24</option>
                              <option>25</option>
                              <option>26</option>
                              <option>27</option>
                              <option>28</option>
                              <option>29</option>
                              <option>30</option>
                              <option>31</option>
                              <option>32</option>
                              <option>33</option>
                              <option>34</option>
                              <option>35</option>
                              <option>36</option>
                              <option>37</option>
                              <option>38</option>
                              <option>39</option>
                              <option>40</option>
                              <option>41</option>
                              <option>42</option>
                              <option>43</option>
                              <option>44</option>
                              <option>45</option>
                              <option>46</option>
                              <option>47</option>
                              <option>48</option>
                              <option>49</option>
                              <option>50</option>
                              <option>51</option>
                              <option>52</option>
                              <option>54</option>
                              <option>55</option>
                              <option>56</option>
                              <option>57</option>
                              <option>58</option>
                              <option>59</option>
                              <option>60</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="city">
                        <label className="left">
                          Fullname <span style={{ color: "#9a2839" }}>*</span>
                        </label>
                        <input
                          className="right"
                          type="text"
                          id="name"
                          placeholder="Your Name.."
                          onChange={(e) =>
                            setInput({ ...input, name: e.target.value })
                          }
                        />
                      </div>
                      <div className="city">
                        <label className="left">
                          Telephone <span style={{ color: "#9a2839" }}>*</span>
                        </label>
                        <input
                          className="right"
                          type="tel"
                          id="name"
                          placeholder="Your Phone Number.."
                          onChange={(e) =>
                            setInput({ ...input, phoneNumber: e.target.value })
                          }
                        />
                      </div>
                      <div className="city">
                        <label className="left">
                          Email Address{" "}
                          <span style={{ color: "#9a2839" }}>*</span>
                        </label>
                        <input
                          className="right"
                          type="email"
                          id="name"
                          placeholder="Your Email Address.."
                          onChange={(e) =>
                            setInput({ ...input, emailAddress: e.target.value })
                          }
                        />
                      </div>

                      <button type="button" onClick={submit}>
                        Send Request!
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="banner-thumb">
                <img src="assets/images/banner/01.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="all-shapes">
        <img
          src="assets/images/banner/banner-shapes/01.png"
          alt="shape"
          className="banner-shape shape-1"
        />
        <img
          src="assets/images/banner/banner-shapes/02.png"
          alt="shape"
          className="banner-shape shape-2"
        />
        <img
          src="assets/images/banner/banner-shapes/03.png"
          alt="shape"
          className="banner-shape shape-3"
        />
        <img
          src="assets/images/banner/banner-shapes/04.png"
          alt="shape"
          className="banner-shape shape-4"
        />
        <img
          src="assets/images/banner/banner-shapes/05.png"
          alt="shape"
          className="banner-shape shape-5"
        />
        <p alt="shape" className="banner-shape shape-6">
          Get Married, Stay Happy <br />
          by Connecting with Eligible <br />
          Bachelors on Tegal
        </p>
        <img
          src="assets/images/banner/banner-shapes/07.png"
          alt="shape"
          className="banner-shape shape-7"
        />
        <img
          src="assets/images/banner/banner-shapes/08.png"
          alt="shape"
          className="banner-shape shape-8"
        />
      </div>
    </section>
  );
}

export default BannerSection;
